import { useEffect } from 'react'
import Socket from '../socket'

export default ({ onInit }) => {
  /** 订阅ws更新审批数量的话题 */
  useEffect(() => {
    const topic = [
      {
        room: false,
        topicKey: process.env.REACT_APP_TOPICKEY || 'zhiyi_saas_prod'
      }
    ]
    Socket.subscribe(topic, (conetnt, messageType) => {
      if (messageType === 0) {
        onInit()
      }
    })
    return () => {
      Socket.cancelSub(topic)
    }
  }, [Socket.subscribe])
}
